const STATUS_INDICATORS = {
  1: "Active",
  2: "Inactive",
  3: "Suspended"
};

export default STATUS_INDICATORS;
